export const API_BASE_URL = import.meta.env.VITE_API_URL;

export const enum THEME {
  DARK = "dark",
  LIGHT = "light",
}

export const BANNER_DISMISS_KEY = "banner_dismiss_key"
// Configuration object for easy maintenance and scaling
export const BANNER_CONFIG = {
  maintenance: {
    bg: "bg-[#005587]",
    text: "text-white",
    closeHover: "hover:bg-white/20",
  },
  info: {
    bg: "bg-blue-50",
    text: "text-blue-800",
    closeHover: "hover:bg-blue-100",
  },
  success: {
    bg: "bg-green-50",
    text: "text-green-800",
    closeHover: "hover:bg-green-100",
  },
  warning: {
    bg: "bg-yellow-50",
    text: "text-yellow-800",
    closeHover: "hover:bg-yellow-100",
  },
  error: {
    bg: "bg-red-50",
    text: "text-red-800",
    closeHover: "hover:bg-red-100",
  },
} as const;


export const TOASTER_CONFIG = {
  className: "",
  style: {
    border: "1px solid #e2e8f0",
    borderRadius: "0.75rem",
    boxShadow: "1px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
  },
  success: {
    iconTheme: {
      primary: "#10B981",
      secondary: "#fff",
    },
  },
  error: {
    iconTheme: {
      primary: "#EF4444",
      secondary: "#fff",
    },
  },
};

export const ROLES = {
  ADMIN: "Admin",
  USER: "User"
}

export type BannerVariant = keyof typeof BANNER_CONFIG;

export const REPORT_ISSUE_URL = "https://chop.service-now.com/esc?id=sc_cat_item&sys_id=7b9abbfa1bf846503ee82139b04bcbe7&sysparm_variable_values=%7B%22select%5Fthe%5Fapplication%22%3A%2210e65979c3a492905566251ce001316e%22%7D"